import { getStorageToken } from "@helpers/storage";
import { AxiosRequestConfig } from "axios";

export const baseUrl: string = process.env.NEXT_PUBLIC_BASE_URL as string;

const ForgotPasswordServices = {
  POSTSendOTPService: (params: {
    type: string;
    identifier: string;
    generateToken?: string;
  }, language: string): AxiosRequestConfig => ({
    url: `${baseUrl}/users-management/v3/auth/otp-send`,
    method: "POST",
    data: { type: params.type, identifier: params.identifier },
    headers: {
      Authorization: `Bearer ${
        params.generateToken ? params.generateToken : getStorageToken().accessToken
      }`,
      lang: language
    },
  }),
  POSTVerifyOTPService: (
    params: {
      identifier: string;
      otp: string | undefined;
      signatureCode: string;
    },
    token: string,
    language: string
  ): AxiosRequestConfig => ({
    url: `${baseUrl}/users-management/v3/auth/otp-verify`,
    method: "POST",
    data: params,
    headers: {
      Authorization: `Bearer ${token ? token : getStorageToken().accessToken}`,
      lang: language
    },
  }),
  PUTResetPasswordService: (
    params: {
      identifier: string;
      otp: string;
      signatureCode: string;
      newPassword?: string;
      reEnterNewPassword?: string;
    },
    token: string,
    language: string
  ): AxiosRequestConfig => ({
    url: `${baseUrl}/users-management/v3/auth/password-reset`,
    method: "PUT",
    data: params,
    headers: {
      Authorization: `Bearer ${token}`,
      lang: language
    },
  }),
};

export default ForgotPasswordServices;
